import L from 'leaflet';
import type { DeviceStatus } from '../../../domain/Device';

const ONLINE_COLOR = '#4E7894';
const OFFLINE_COLOR = '#9ca3af';

// Un pin por estación; gris cuando está offline para distinguir de un
// vistazo cuáles no están reportando.
export function deviceMarkerIcon(status: DeviceStatus): L.DivIcon {
  const color = status === 'online' ? ONLINE_COLOR : OFFLINE_COLOR;
  return L.divIcon({
    className: 'domiot-device-marker',
    html: `<span style="display:block;width:18px;height:18px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 0 3px rgba(0,0,0,0.5);"></span>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -9],
  });
}
